/* jshint esversion: 6 */
import React from 'react';
import { Map, AdvancedMarker } from '@vis.gl/react-google-maps';
import Toggle from 'app/components/common/ToggleControl.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputLocationPanel extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			currentMap: null,
			marker: null
		};

		this.getMapOptions = this.getMapOptions.bind(this);
		this.getDefaultLocation = this.getDefaultLocation.bind(this);
		this.placeMarker = this.placeMarker.bind(this);
		this.removeMarker = this.removeMarker.bind(this);
		this.updateGeoCoordinates = this.updateGeoCoordinates.bind(this);

	}

	componentDidMount() {
		this.setState({
			marker: this.getDefaultLocation()
		});
	}

	getMapOptions() {
		return {
			defaultCenter: this.getDefaultLocation(),
	        defaultZoom: 6,
	        disableDefaultUI: true,
	        gestureHandling: 'auto',
	        zoomControl: true,
	        disableDoubleClickZoom: false
		}
	}

	getDefaultLocation() {
		// dateline portlandia
		let location = {lat: 45.5236111, lng: -122.675};

		if (this.props.input !== undefined && this.props.input.defaultGeo !== undefined && this.props.input.defaultGeo.length > 0) {
			location = {lat: parseFloat(this.props.input.defaultGeo[0]), lng: parseFloat(this.props.input.defaultGeo[1])};
		} else if (window.navigator.geolocation) {
			window.navigator.geolocation.getCurrentPosition((position) => {
				location = {lat: position.coords.latitude, lng: position.coords.longitude};
	        });
		}

		return location;

	}

	placeMarker(e) {
		let marker = this.state.marker;

		// e.detail.latLng = {lat:, lng:}
		if (e.detail !== undefined && e.detail.latLng !== undefined) {
			if (!marker || (marker.lat !== e.detail.latLng && marker.lng !== e.detail.latLng)) {
				this.setState({
					marker: e.detail.latLng
				});
			}
			this.updateGeoCoordinates([e.detail.latLng.lat, e.detail.latLng.lng]);
		}

	}

	removeMarker(e) {
		this.setState({
			marker: null
		});
		this.updateGeoCoordinates([]);
	}

	updateGeoCoordinates(coordinates) {
		// 'event' sent up the chain to update the new coordinates
		this.props.changeHandler({
	    	currentTarget: {
	    		dataset: {
	    			field: this.props.statePath + '.defaultGeo'
	    		}
	    	},
	    	target: {
	    		value: coordinates
	    	}
	    });
	}

	render() {
		let useGeo = (this.props.input.useGeo) ? true : false,
			overrideItemGeo = (this.props.input.overrideItemGeo) ? true : false,
			defaultGeo = (this.props.input.defaultGeo) ? this.props.input.defaultGeo : {},
			map = null,
			override = null,
			mapLegend = "Set your feed's default location";

		if (useGeo) {
			map = (
				<fieldset>
					<legend>{mapLegend}<HelpButton which="defaultGeo"/></legend>
					<div className="editor-control map">
						<Map mapId="41e3688e931f3e8d" {...this.getMapOptions()} onClick={this.placeMarker}>
							{this.state.marker !== null ? (
								<AdvancedMarker position={this.state.marker} onClick={this.removeMarker}/>
							) : null}
						</Map>
					</div>
				</fieldset>
			);
			override = (
				<fieldset>
					<legend>Default location overrides item location<HelpButton which="overrideItemGeo"/></legend>
					<Toggle active={overrideItemGeo}
									callback={this.props.changeHandler}
									noLabel={true}
									linkedField={this.props.statePath + ".overrideItemGeo"}/>
				</fieldset>
			);
		}

		return (
			<div className="editor-panel">
				<form>
					<fieldset>
						<legend>Use Location<HelpButton which="useGeo"/></legend>
						<Toggle active={useGeo}
								callback={this.props.changeHandler}
								noLabel={true}
								linkedField={this.props.statePath + ".useGeo"} />
					</fieldset>
					{map}
					{override}
				</form>
			</div>
		);
	}
};

InputLocationPanel.displayName = "InputLocationPanel";

export default ComponentWithContext(InputLocationPanel);
